import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  FormGroup,
  Label,
  Row,
  Col,
  Input,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import moment from "moment";
import {
  getUserLocations,
  // getUserSubLocations,
  getMiniDepartment,
  getUserDepartment,
} from "../../../store/Mini/actions";
import {
  getPIreportslist,
  PIreportslistSuccessful,
  reportTypeCheck,
  SetParams,
  ReportsChangeValue,
  ReportsSelecteChangeValue,
} from "../../../store/Reports/actions";
var date = new Date(),
  y = date.getFullYear(),
  m = date.getMonth();
class PIReports extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.ReportsChangeHandeler = this.ReportsChangeHandeler.bind(this);
  }

  componentDidMount() {
    this.props.getUserLocations();
    this.props.getUserDepartment();
    this.props.getMiniDepartment();
    this.props.SetParams({});
  }
  ReportsChangeHandeler(e) {
    this.props.ReportsChangeValue({
      key: e.target.name,
      value: e.target.value,
    });
    if (this.props.reportType === "document") {
      this.props.getPIreportslist({
        ...this.props.params,
        [e.target.name]: e.target.value,
      });
    }
  }
  SelecteChangeValue({ key, label, key2, value }) {
    this.props.ReportsSelecteChangeValue({
      key,
      label,
      key2,
      value,
    });
    if (this.props.reportType === "document") {
      this.props.getPIreportslist({
        ...this.props.params,
        [key2]: value,
      });
    }
  }
  reportType(e) {
    this.props.reportTypeCheck({ value: e.target.value });

    this.props.PIreportslistSuccessful([]);
    if (e.target.value === "document") {
      this.props.getPIreportslist({
        ...this.props.params,
        start_date:
          this.props.params.start_date == null ||
          this.props.params.start_date === ""
            ? moment(new Date(y, m, 1)).format("YYYY-MM-DD")
            : this.props.params.start_date,
        end_date:
          this.props.params.end_date == null ||
          this.props.params.end_date === ""
            ? moment(new Date()).format("YYYY-MM-DD")
            : this.props.params.end_date,
      });
    }
  }
  reportCheck(e) {
    this.props.ReportsChangeValue({
      key: "action",
      value: e.target.value,
    });
  }
  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col md={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom ">
                    <Link
                      to="/reports"
                      className="action-icon text-primary mr-2"
                    >
                      <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                    </Link>
                    <h5 className="card-title-18 pt-2 d-inline-block">
                      Purchase Indent Report
                    </h5>
                  </CardHeader>
                  <CardBody className="pt-1">
                    <Row className="p-1">
                      <Col md={12}>
                        <Card className="p-1">
                          <CardBody className="pt-1">
                            <Row>
                              <Col md={3} className="mb-0">
                                <FormGroup className="mb-0 pb-0">
                                  <Label
                                    htmlFor="validationFromDate"
                                    className="col-form-label"
                                  >
                                    From Date:
                                  </Label>

                                  <Input
                                    className="mb-0 form-control "
                                    type="date"
                                    value={
                                      this.props.params.start_date == null ||
                                      this.props.params.start_date === ""
                                        ? moment(new Date(y, m, 1)).format(
                                            "YYYY-MM-DD"
                                          )
                                        : this.props.params.start_date
                                    }
                                    onChange={(e) => {
                                      this.ReportsChangeHandeler(e);
                                    }}
                                    id="CProduct-Name-text-input"
                                    name="start_date"
                                    placeholder="select Date"
                                    max={moment(new Date()).format(
                                      "YYYY-MM-DD"
                                    )}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={3} className="mb-0">
                                <FormGroup className="mb-0 pb-0">
                                  <Label
                                    htmlFor="validationToDate"
                                    className="mb-0 col-form-label"
                                  >
                                    To Date:
                                  </Label>

                                  <Input
                                    className="mb-0 form-control "
                                    type="date"
                                    value={
                                      this.props.params.end_date == null ||
                                      this.props.params.end_date === ""
                                        ? moment(new Date()).format(
                                            "YYYY-MM-DD"
                                          )
                                        : this.props.params.end_date
                                    }
                                    onChange={(e) => {
                                      this.ReportsChangeHandeler(e);
                                    }}
                                    id="CProduct-Name-text-input"
                                    name="end_date"
                                    placeholder="select Date"
                                    disabled={
                                      this.props.params.start_date === ""
                                        ? true
                                        : false
                                    }
                                    min={this.props.params.start_date == null ||
                                      this.props.params.start_date === ""
                                        ? moment(new Date(y, m, 1)).format(
                                            "YYYY-MM-DD"
                                          )
                                        : moment(this.props.params.start_date).format(
                                          "YYYY-MM-DD"
                                        )}
                                    max={moment(new Date()).format(
                                      "YYYY-MM-DD"
                                    )}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={3}>
                                <FormGroup className="mb-0">
                                  <Label
                                    htmlFor="Location-selection"
                                    className="col-form-label"
                                  >
                                    Locations :
                                  </Label>

                                  <Select
                                    id="Department-selection"
                                    name="Department-selection"
                                    classNamePrefix="select2-selection"
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    options={this.props.userLocation.map(
                                      (item, index) => ({
                                        label: item.name,
                                        value: item.id,
                                      })
                                    )}
                                    value={{
                                      label:
                                        this.props.Reportdata?.locationlabel,
                                      value: this.props.params?.location,
                                    }}
                                    onChange={(e) => {
                                      this.SelecteChangeValue({
                                        key: "locationlabel",
                                        label: e.label,
                                        key2: "location",
                                        value: e.value,
                                      });
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={3}>
                                <FormGroup className="mb-0">
                                  <Label
                                    htmlFor="Department-selection"
                                    className="col-form-label"
                                  >
                                    Department:
                                  </Label>

                                  <Select
                                    id="Department-selection"
                                    name="Department-selection"
                                    classNamePrefix="select2-selection"
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    options={this.props.deparmentslist.map(
                                      (item, index) => ({
                                        label: item.name,
                                        value: item.id,
                                      })
                                    )}
                                    value={{
                                      label:
                                        this.props.Reportdata?.deparmentslabel,
                                      value: this.props.params?.deparment,
                                    }}
                                    onChange={(e) => {
                                      this.SelecteChangeValue({
                                        key: "deparmentslabel",
                                        label: e.label,
                                        key2: "deparments",
                                        value: e.value,
                                      });
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={3}>
                                <FormGroup className="mb-0">
                                  <Label
                                    htmlFor="UserDepartment-selection"
                                    className="col-form-label"
                                  >
                                    User Department :
                                  </Label>

                                  <Select
                                    id="UserDepartment-selection"
                                    name="UserDepartment-selection"
                                    classNamePrefix="select2-selection"
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    options={this.props.userDeparment.map(
                                      (item, index) => ({
                                        label: item.name,
                                        value: item.id,
                                      })
                                    )}
                                    value={{
                                      label:
                                        this.props.Reportdata
                                          ?.userdepartmentlabel,
                                      value: this.props.params?.userdepartment,
                                    }}
                                    onChange={(e) => {
                                      this.SelecteChangeValue({
                                        key: "userdepartmentlabel",
                                        label: e.label,
                                        key2: "userdepartment",
                                        value: e.value,
                                      });
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              <Col
                                md={3}
                                className="mt-1 text-center font-size-14"
                              >
                                <div className="mb-1">
                                  <Label>&nbsp;</Label>
                                </div>
                                <div className="border p-2">
                                  <div className="radio d-inline-block mr-5">
                                    <Input
                                      type="radio"
                                      value="list"
                                      name="reportType"
                                      id="List"
                                      checked={
                                        // true
                                        this.props.reportType === "list"
                                          ? true
                                          : false
                                      }
                                      onClick={(e) => this.reportType(e)}
                                    />
                                      <label htmlFor="List"><span id="__List">List</span></label>
                                 
                                  </div>
                                  <div className="radio d-inline-block">
                                    <Input
                                      type="radio"
                                      value="document"
                                      name="reportType"
                                      checked={
                                        this.props.reportType === "document"
                                          ? true
                                          : false
                                      }
                                      onClick={(e) => this.reportType(e)}
                                    />
                                    Document
                                  </div>
                                </div>
                              </Col>
                              {this.props.reportType === "document" && (
                                <Col md={3}>
                                  <FormGroup className="mb-0">
                                    <Label
                                      htmlFor="MR_Code-selection"
                                      className="col-form-label"
                                    >
                                      PI Code :
                                    </Label>

                                    <Select
                                      id="MR_Code-selection"
                                      name="MR_Code-selection"
                                      classNamePrefix="select2-selection"
                                      menuPortalTarget={document.body}
                                      styles={{
                                        menuPortal: (base) => ({
                                          ...base,
                                          zIndex: 9999,
                                        }),
                                      }}
                                      options={this.props.PI_ReportData.map(
                                        (item, index) => ({
                                          label: item.code,
                                          value: item.id,
                                        })
                                      )}
                                      value={{
                                        label:
                                          this.props.Reportdata?.PICodelabel,
                                        value: this.props.params?.PIId,
                                      }}
                                      onChange={(e) => {
                                        this.SelecteChangeValue({
                                          key: "PICodelabel",
                                          label: e.label,
                                          key2: "PIId",
                                          value: e.value,
                                        });
                                      }}
                                    />
                                  </FormGroup>
                                </Col>
                              )}
                            </Row>

                            <Row>
                              <Col md={12} className="mt-1">
                                <div className="float-right pt-1">
                                  {this.props.reportType === "document" && (
                                    <Link
                                      to={
                                        "/pireportdoc/" + this.props.params.PIId
                                      }
                                    >
                                      <Button
                                        block
                                        type="button"
                                        color="primary"
                                        disabled={
                                          this.props.params.PIId == null ||
                                          this.props.params.PIId === ""
                                            ? true
                                            : false
                                        }
                                        className="waves-effect waves-light"
                                      >
                                        Generate Report
                                      </Button>
                                    </Link>
                                  )}

                                  {this.props.reportType === "list" && (
                                    <Link to="/pireportlist">
                                      <Button
                                        block
                                        type="button"
                                        color="primary"
                                        className="waves-effect waves-light"
                                      >
                                        Generate Report
                                      </Button>
                                    </Link>
                                  )}
                                </div>
                              </Col>
                            </Row>
                            {/* </div> */}
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { userLocation, userDeparment, deparmentslist } = state.Mini;

  const { params, reportType, Reportdata, PI_ReportData } = state.reports;
  return {
    userLocation,
    userDeparment,
    deparmentslist,
    reportType,
    params,
    Reportdata,
    PI_ReportData,
    //-------
  };
};

export default connect(mapStatetoProps, {
  getUserLocations,
  getMiniDepartment,
  // getUserSubLocations,
  getUserDepartment,
  getPIreportslist,
  reportTypeCheck,
  SetParams,
  ReportsChangeValue,
  ReportsSelecteChangeValue,
  PIreportslistSuccessful,
})(PIReports);
